import { render, staticRenderFns } from "./FormOrdemServico.vue?vue&type=template&id=4256de16"
import script from "./FormOrdemServico.vue?vue&type=script&lang=js"
export * from "./FormOrdemServico.vue?vue&type=script&lang=js"
import style0 from "./FormOrdemServico.vue?vue&type=style&index=0&id=4256de16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports